import AccessServiceTypes from '../../domain/AccessServiceTypes';
import VideoTypes from '../../domain/VideoTypes';

export const isSameAccessService = (accessService, preferredAccessVersion) => {
    switch (preferredAccessVersion) {
        case AccessServiceTypes.SIGNINTERPRETATION:
        case AccessServiceTypes.SIGN_LANGUAGE:
            return (
                accessService === AccessServiceTypes.SIGNINTERPRETATION ||
                accessService === AccessServiceTypes.SIGN_LANGUAGE
            );
        default:
            return accessService === preferredAccessVersion;
    }
};

export const getUrl = (content, preferredAccessVersion) => {
    if (content.versions && preferredAccessVersion) {
        for (let i = 0; i < content.versions.length; i++) {
            const version = content.versions[i];
            if (isSameAccessService(version.accessService, preferredAccessVersion)) {
                return version.contentUrl;
            }
        }
    }

    return content.contentUrl;
};

export const getSubtitle = (slidableListId, content) => {
    if (slidableListId === 'recommended') {
        return content.title;
    } else if (content.contentType === VideoTypes.CLIP) {
        return `Längd: ${content.durationFormatted}`;
    } else if (
        slidableListId !== 'recommended' &&
        content.contentType !== VideoTypes.TITLE &&
        content.contentType !== VideoTypes.CLIP &&
        !content.movie
    ) {
        if (content && content.season) {
            return `Säsong ${content.season}`;
        }

        return content.title;
    }

    return null;
};
